import { BaseFieldModel, IBaseFieldModel } from '../base/blueprint-field-base.model';

export interface IRadioButtonGroupModel extends IBaseFieldModel {
  isRequired: boolean;
  isReadOnly: boolean;
  hasDefault: boolean;
  options: Array<string>;
  value: string;
}
export class RadioButtonGroupModel extends BaseFieldModel implements IRadioButtonGroupModel {
  constructor(
    public isRequired: boolean,
    public isReadOnly: boolean,
    public hasDefault: boolean,
    public options: Array<string>,
    public value: string,
  ) {
    super(isRequired, isReadOnly);
  }
}
